import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ORDER_CONFIRMATION_ANALYTICS_ACTIONS } from '../tracking/analytics/order-confirmation-analytics.actions';
import { Tracking } from '@panamax/app-state';
import { OrderConfirmationAnalyticsMessages } from '../tracking/analytics/order-confirmation-analytics.constants';
import { genericAnalyticsTransformer } from '@shared/tracking/analytics/generic-analytics-transformer';

@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationService {
  constructor(private store: Store) {}

  public downloadOrderConfirmationAnalytics(
    fileType: string,
    orderId: string,
    fileCount: number,
  ) {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: OrderConfirmationAnalyticsMessages.event,
          capability: OrderConfirmationAnalyticsMessages.capability,
          file: {
            type: OrderConfirmationAnalyticsMessages.downloadType + fileType,
            fileCount: fileCount,
          },
          order: {
            id: orderId,
          },
        },
        transformFunc: genericAnalyticsTransformer,
      },
    };
    this.store.dispatch(
      ORDER_CONFIRMATION_ANALYTICS_ACTIONS.trackOrderConfirmationDownload({
        tracking,
      }),
    );
  }
}
